import { Lookups } from '@precert/validation';
import { format } from 'date-fns';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Row, Col } from 'reactstrap';

import { AutoFocusHeader } from '../../../../_components/auto-focus-header';
import { useSteps } from '../steps/use-steps';

import styles from './step-header.module.scss';

const { GenderOptions } = Lookups;

export default function StepHeader() {
  const { getValues } = useFormContext();
  const { currentStep } = useSteps();
  const veteranDemographic =
    getValues('veteranLastName') &&
    getValues('veteranDob') &&
    getValues('veteranGender');
  return (
    <>
      <Row className="d-flex pb-0">
        <Col sm={12} md={4} lg={4} xl={3} className="d-inline">
          <AutoFocusHeader
            className="pt-2"
            id="stepTitle"
            style={{ fontSize: '1.5rem' }}
            tabIndex={0}
          >
            {currentStep.title}
          </AutoFocusHeader>
        </Col>
        {veteranDemographic && (
          <aside
            className="col-sm-12 col-md-8 col-lg-8 col-xl-9"
            aria-label="Patient Banner"
          >
            <div className="alert alert-info rounded flex-grow-1 mb-0">
              <div className="d-flex justify-content-around">
                <div
                  className="fw-bold"
                  aria-label="Veteran LastName, Veteran Firstname"
                >
                  {getValues('veteranLastName').toUpperCase()}
                  {getValues('veteranFirstName')?.trim() &&
                    `, ${getValues('veteranFirstName')}`}
                </div>
                <div className="text-center">
                  <span className="fw-bold" aria-label="Veteran Date Of Birth">
                    DOB:{' '}
                  </span>
                  {format(new Date(getValues('veteranDob')), 'MM/dd/yyyy')}
                </div>
                <div>
                  <span className="fw-bold" aria-label="Veteran Gender">
                    Gender:{' '}
                  </span>
                  {GenderOptions[getValues('veteranGender')]}
                </div>
              </div>
            </div>
          </aside>
        )}
      </Row>
      {currentStep.title === 'Clinical Notes' ? null : (
        <>
          <div className={styles.legend} tabIndex={0}>
            Indicates required field
          </div>
          <hr aria-hidden="true" />
        </>
      )}
    </>
  );
}
